<template>
  <vis-loading :loading="isLoading" vclass="vis-has-toolbar">

    <div v-if="isAccessGranted" class="h-100">
      <vis-toolbar :items="toolbar" class="vis-grid-toolbar" />
      <vis-base-grid
        :columns="gridColumns"
        :dataSource="dataSource"
        @select="onSelect"
        @dblclick="edit"
        class="h-100"
      />
      <vis-edit-company-form
        v-if="editMode"
        :visible="editMode"
        :company="selectedItems[0]"
        @hide="updateCompanyList"
      />
    </div>

    <div v-else class="ba-flex ba-justify-center">
      {{$t("accessDenied")}}
    </div>
    
  </vis-loading>
</template>
<script>
import VisEditCompanyForm from "@/views/admin/vis-edit-company-form";
import ArrayStore from 'devextreme/data/array_store';
import paymentApi from "@/api/payment-api";
import api from "@/api/visary-api"

export default {
  name: "vis-payment-options",
  components: {
    VisEditCompanyForm
  },
  data(vm) {
    return {
      isAccessGranted: false,
      dataSource: null,
      selectedItems: null,
      editMode: false,
      isLoading: false,
      companies: [],
      toolbar: [
        {
          id: "buttons",
          type: "button-group",
          buttons: [
            {
              id: "edit",
              icon: "far fa-pencil",
              title: vm.$t("edit"),
              disabled: true,
              order: 10,
              onClick: () => vm.editMode = true,
              updateState() {
                this.disabled = vm.selectedItems.length !== 1;
              }
            },
            {
              icon: "fal fa-question",
              type: "vis-mnemonic-help-toolbar-button",
              mnemonic: "PaymentOptionsHelpFile",
              title: this.$t("toolbar.button.Help"),
            }
          ]
        }
      ],
      gridColumns: [
        {
          field: "Id",
          title: "ID",
          type: "Number",
        },
        {
          field: "Name",
          title: vm.$t('gridPreset.Title'),
          type: "String",
        },
        {
          field: "MerchantId",
          title: vm.$t('payment.merchantId'),
          type: "String",
          allowSorting: false
        },
        {
          field: "CallbackSecret",
          title: vm.$t('payment.callbackSecret'),
          type: 'String',
          allowSorting: false
        },
      ],
    };
  },
  methods: {
    async checkAccess() {
      this.isLoading = true
      try {
        this.isAccessGranted = await api.user.checkPathAccess({ path: this.$route.path })
      } catch(err) {
        console.error(err)
      } finally{
        this.isLoading = false
      }
    },
    async loadCompanies() {
      this.isLoading = true;
      try {
        this.companies = await paymentApi.getAllCompanies()
      } catch(err) {
        console.error(err)
      } finally{
        this.isLoading = false
      }
    },
    bindData() {
      this.dataSource = new ArrayStore({
        key: "Id",
        data: this.companies
      });
    },
    onSelect(event) {
      this.selectedItems = event.items;
      this.updateToolbarState();
    },
    edit(event) {
      this.selectedItems = [ event.data ];
      this.editMode = true;
    },
    updateToolbarState() {
      this.toolbar.forEach(t => {
        if (t.buttons)
          t.buttons.forEach(b => {
            if (b.updateState) b.updateState();
          });
      });
    },
    async updateCompanyList() {
      this.editMode = false
      await this.loadCompanies()
      this.bindData()
    }
  },
  async mounted() {
    await this.checkAccess()
    if (!this.isAccessGranted) return
    await this.updateCompanyList()
  }
};
</script>
